import { api } from "./api";

export const getMySessionsApi = () => api.get('/hub/session/my');
export const terminateSessionApi = (id) => api.delete(`/hub/session/${id}`);
export const terminateOtherSessionsApi = () => api.delete('/hub/session/others');

export const adminGetUserSessionsApi = (userId) => api.get(`/hub/admin/users/${userId}/sessions`);
export const adminGetUserSessionHistoryApi = (userId, page = 1) => api.get(`/hub/admin/users/${userId}/sessions/history?page=${page}`);
export const adminTerminateSessionApi = (userId, id) => api.delete(`/hub/admin/users/${userId}/sessions/${id}`);
export const adminTerminateAllSessionsApi = (userId) => api.delete(`/hub/admin/users/${userId}/sessions/all`);
